<template>
  <footer class="app-footer">
    <div class="app-footer__inner">
      <div class="app-footer__brand">
        <div class="app-footer__logo">
          <img src="https://lib.jiangnan.edu.cn/img/logo.png" alt="江南大学">
        </div>
        <div class="app-footer__divider" />
        <div class="app-footer__title-block">
          <h2 class="app-footer__title">中国民族工商文化特色资源库</h2>
          <p class="app-footer__subtitle">ZHONG GUO MING ZU GONG SHANG WEN HUA TE SE ZI YUAN KU</p>
        </div>
      </div>

      <div class="app-footer__links">
        <span class="app-footer__links-label">友情链接：</span>
        <a
          v-for="(link, index) in friendlyLinks"
          :key="`friend-${index}`"
          :href="link.url"
          class="app-footer__link"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ link.label }}
        </a>
      </div>

      <div class="app-footer__links">
        <span class="app-footer__links-label">校内站点：</span>
        <a
          v-for="(link, index) in campusLinks"
          :key="`campus-${index}`"
          :href="link.url"
          class="app-footer__link"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ link.label }}
        </a>
      </div>

      <ul class="app-footer__contact">
        <li>地址：江苏省无锡市蠡湖大道1800号</li>
        <li>邮编：214122</li>
        <li>电话：0510-85327765（图书馆），0510-85328362（档案馆）</li>
        <li>
          服务邮箱：
          <a href="mailto:tsg@jiangnan.edu.cn" class="app-footer__link">tsg@jiangnan.edu.cn</a>
        </li>
      </ul>

    </div>
  </footer>
</template>

<script>
const LIBRARY_FRIEND_LINKS = [
  { label: '江南大学', url: 'https://www.jiangnan.edu.cn/' },
  { label: '教育部高校图工委', url: 'http://www.scal.edu.cn/' },
  { label: '江苏省高校图工委', url: 'https://jstgw.nju.edu.cn/' },
  { label: 'CALIS', url: 'http://opac.calis.edu.cn/opac/simpleSearch.do' },
  { label: 'CADAL', url: 'https://cadal.edu.cn/index/home' },
  { label: 'JALIS', url: 'https://jalis.nju.edu.cn/' }
]

const CAMPUS_LINKS = [
  { label: '江南大学', url: 'http://www.jiangnan.edu.cn/' },
  { label: '档案馆', url: 'http://dangan.jiangnan.edu.cn/' },
  { label: 'e江南', url: 'https://e.jiangnan.edu.cn/' },
  { label: '信息化建设管理处', url: 'http://nic.jiangnan.edu.cn/' }
]

export default {
  name: 'AppFooter',
  props: {
    friendlyLinks: {
      type: Array,
      default() {
        return LIBRARY_FRIEND_LINKS
      }
    },
    campusLinks: {
      type: Array,
      default() {
        return CAMPUS_LINKS
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.app-footer {
  background: $color-brown-footer;
  color: $color-white;
  padding: $spacing-3xl 0 $spacing-2xl;

  &__inner {
    @include page-container;
    display: flex;
    flex-direction: column;
    gap: $spacing-xl;
  }

  &__brand {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: $spacing-xl;
    flex-wrap: wrap;
  }

  &__logo {
    display: flex;
    align-items: center;
    gap: $spacing-md;

    img {
      width: 220px;
      height: 50px;
      object-fit: contain;
    }
  }

  &__divider {
    width: 1px;
    height: 56px;
    background: rgba($color-white, 0.3);
  }

  &__title-block {
    text-align: left;
  }

  &__title {
    font-family: $font-serif;
    font-size: rem(28);
    font-weight: 600;
    letter-spacing: 3px;
    line-height: 1.3;
  }

  &__subtitle {
    font-size: rem(11);
    letter-spacing: 2px;
    opacity: 0.75;
    margin-top: $spacing-sm;
  }

  &__links,
  &__contact {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: $spacing-base;
    font-size: rem(13);
  }

  &__links-label {
    opacity: 0.9;
  }

  &__link {
    opacity: 0.85;
    color: inherit;
    transition: opacity 0.2s;

    &:hover {
      opacity: 1;
      text-decoration: underline;
    }
  }

  &__contact {
    list-style: none;
    margin: 0;
    padding: 0;
    opacity: 0.85;
    line-height: 1.8;
  }
}

@media (max-width: 768px) {
  .app-footer {
    &__brand {
      flex-direction: column;
      text-align: center;
    }

    &__divider {
      width: 80%;
      height: 1px;
    }

    &__title-block {
      text-align: center;
    }

    &__title {
      font-size: rem(22);
    }

    &__contact {
      flex-direction: column;
      gap: $spacing-xs;
    }
  }
}
</style>
